import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-cinema-dark border-t border-cinema-border">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-cinema-gold font-heading text-xl font-bold tracking-wider">
                8090<span className="text-white">影视</span>
              </span>
            </Link>
            <p className="text-cinema-text-dim text-sm leading-relaxed">
              8090影视打造电影大全平台，聚合最新电影、经典电影、高清电影资源，为您提供优质的在线观影体验。
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-cinema-card text-cinema-text-dim hover:text-cinema-gold transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-cinema-card text-cinema-text-dim hover:text-cinema-gold transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-cinema-card text-cinema-text-dim hover:text-cinema-gold transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-heading text-base font-semibold mb-4">电影分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-cinema-text-dim text-sm hover:text-cinema-gold transition-colors cursor-pointer"
                  >
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading text-base font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-cinema-text-dim text-sm hover:text-cinema-gold transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/zuixin" className="text-cinema-text-dim text-sm hover:text-cinema-gold transition-colors cursor-pointer">
                  最新上映
                </Link>
              </li>
              <li>
                <Link to="/category/gaofen" className="text-cinema-text-dim text-sm hover:text-cinema-gold transition-colors cursor-pointer">
                  高分推荐
                </Link>
              </li>
              <li>
                <Link to="/category/jingdian" className="text-cinema-text-dim text-sm hover:text-cinema-gold transition-colors cursor-pointer">
                  经典电影
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-cinema-text-dim text-sm hover:text-cinema-gold transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading text-base font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-cinema-text-dim text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-cinema-gold"></i>
                <span>contact@8090movie.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-cinema-gold"></i>
                <span>400-800-8090</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-cinema-gold"></i>
                <span>北京市朝阳区影视产业园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-cinema-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-cinema-text-dim text-xs">
            &copy; {new Date().getFullYear()} 8090影视 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-cinema-text-dim text-xs hover:text-cinema-gold transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-cinema-text-dim text-xs hover:text-cinema-gold transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-cinema-text-dim text-xs hover:text-cinema-gold transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}